<template>
  <div class="wizard-footer d-flex justify-space-between align-center pa-3">
    <v-btn
      v-if="isFirstStep"
      large
      text
      class="wizard-footer-btn wizard-footer-btn--text"
      @click="$emit('cancel')"
    >
      キャンセル
    </v-btn>
    <v-btn
      v-else
      large
      text
      class="wizard-footer-btn wizard-footer-btn--text"
      @click="$emit('prev')"
    >
      戻る
    </v-btn>

    <div
      class="d-flex align-center"
      style="gap: 12px;"
    >
      <v-btn
        v-if="!isLastStep"
        large
        outlined
        color="primary"
        class="wizard-footer-btn"
        :disabled="saveDraftDisabled || submitting"
        @click="$emit('save-draft')"
      >
        一旦作成
      </v-btn>

      <v-btn
        v-if="isLastStep"
        large
        color="primary"
        class="wizard-footer-btn"
        :disabled="nextDisabled || submitting"
        @click="$emit('complete')"
      >
        作成
      </v-btn>
      <v-btn
        v-else
        large
        color="primary"
        class="wizard-footer-btn"
        :disabled="nextDisabled"
        @click="$emit('next')"
      >
        次へ
      </v-btn>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  name: 'WizardFooter',
  props: {
    currentStep: { type: Number, required: true },
    totalSteps: { type: Number, required: true },
    nextDisabled: { type: Boolean, default: false },
    saveDraftDisabled: { type: Boolean, default: false },
    submitting: { type: Boolean, default: false },
  },
  emits: ['prev', 'next', 'complete', 'cancel', 'save-draft'],
  setup(props) {
    const isFirstStep = computed(() => props.currentStep === 1)
    const isLastStep = computed(() => props.currentStep === props.totalSteps)

    return { isFirstStep, isLastStep }
  },
}
</script>

<style scoped>
.wizard-footer {
  background: var(--v-background-base);
  border-top: 1px solid rgba(127, 127, 127, 0.2);
  min-height: 64px;
}
.wizard-footer-btn {
  min-height: 48px;
  min-width: 140px;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.04em;
}
.wizard-footer-btn--text {
  min-width: 100px;
}
</style>
